import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { UserCheck, UserMinus, Gavel } from 'lucide-react';

// Betreuerwechsel als klare Liste (25.10.2026): bisheriger und aktueller Betreuer mit seit/bis und Quelle Gerichtsbeschluss –
// primaere Sicht statt Bubble-Graph. Daten aus dem Betreuungsdatensatz (bisheriger_betreuer, bestellter_betreuer, wirksam_ab, Beschluss).
const de = (iso) => (iso && /^\d{4}-\d{2}-\d{2}/.test(iso) ? `${iso.slice(8, 10)}.${iso.slice(5, 7)}.${iso.slice(0, 4)}` : iso || null);

export function betreuerVerlauf(b) {
  if (!b || !(b.bisheriger_betreuer || b.bestellter_betreuer || b.art === 'betreuerwechsel')) return null;
  const stichtag = de(b.wirksam_ab || b.bestellung_am);
  const quelle = ['Gerichtsbeschluss', b.letzter_beschluss_datum ? `vom ${de(b.letzter_beschluss_datum)}` : null,
    b.gericht ? `(${b.gericht}${b.aktenzeichen ? `, Az. ${b.aktenzeichen}` : ''})` : (b.aktenzeichen ? `(Az. ${b.aktenzeichen})` : null)].filter(Boolean).join(' ');
  const zeilen = [];
  if (b.bisheriger_betreuer || b.art === 'betreuerwechsel') {
    zeilen.push({ rolle: 'Bisheriger Betreuer', name: b.bisheriger_betreuer || null, zeitraum: stichtag ? `bis ${stichtag}` : 'bis: offen', aktuell: false,
      seitBetreuungsbeginn: b.betreuung_seit ? `Betreuung insgesamt seit ${de(b.betreuung_seit)}` : 'Betreuungsbeginn insgesamt (VBVG) offen' });
  }
  zeilen.push({ rolle: 'Aktueller Betreuer', name: b.bestellter_betreuer || null, zeitraum: stichtag ? `seit ${stichtag}` : 'seit: offen', aktuell: true });
  return { zeilen, quelle };
}

export default function BetreuerVerlauf({ betreuung }) {
  const v = betreuerVerlauf(betreuung);
  if (!v) return null;
  return (
    <Card data-testid="betreuer-verlauf">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg flex items-center gap-2"><Gavel className="w-5 h-5 text-slate-600" /> Betreuerwechsel</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        {v.zeilen.map((z) => (
          <div key={z.rolle} className={`flex items-start gap-3 rounded-lg border p-3 ${z.aktuell ? 'border-emerald-200 bg-emerald-50/40' : 'border-slate-200 bg-slate-50'}`}
            data-testid={z.aktuell ? 'betreuer-aktuell' : 'betreuer-bisher'}>
            {z.aktuell ? <UserCheck className="w-5 h-5 text-emerald-600 mt-0.5" /> : <UserMinus className="w-5 h-5 text-slate-400 mt-0.5" />}
            <div className="flex-1 min-w-0">
              <p className="text-xs text-slate-500">{z.rolle}</p>
              <p className={`font-medium ${z.name ? 'text-slate-800' : 'text-amber-600'}`}>{z.name || 'Name nicht im Beschluss – bitte ergänzen'}</p>
              {z.seitBetreuungsbeginn && <p className="text-xs text-slate-500 mt-0.5">{z.seitBetreuungsbeginn}</p>}
            </div>
            <Badge variant="outline" className={z.aktuell ? 'border-emerald-300 text-emerald-700' : 'text-slate-600'}>{z.zeitraum}</Badge>
          </div>
        ))}
        <p className="text-xs text-slate-500" data-testid="betreuer-verlauf-quelle">Quelle: {v.quelle}</p>
      </CardContent>
    </Card>
  );
}
